import React, { Component } from "reactn";
import StripeCmp from "../../components/Payments/stripe_component";
import { StripeProvider, Elements } from "react-stripe-elements";
import { toast } from "react-toastify";
import axios from "axios";
import Switch from "@material-ui/core/Switch";
import { Link } from "react-router-dom";
class GiftCardPurchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image_map: [
        "partners/Gift Cards/zeus-01.png",
        "partners/Gift Cards/zeus-02.png",
        "partners/Gift Cards/zeus-03.png",
        "partners/Gift Cards/zeus-04.png",
        "partners/Gift Cards/zeus-05.png",
        "partners/Gift Cards/zeus-06.png",
        "partners/Gift Cards/zeus-07.png",
        "partners/Gift Cards/zeus-08.png"
      ],
      isForMyself: true
    };
    this.required = [
      { name: "me_name", validation: e => !e },
      { name: "me_email", validation: e => !e }
    ];
    this.recipientRequired = [
      { name: "rec_name", validation: e => !e },
      { name: "rec_email", validation: e => !e }
    ];
  }
  componentDidMount() {
    const Ele = document.getElementsByClassName("StripeElement")[0];
    Ele.style.backgroundColor = "white";
    Ele.style.padding = "12px";
    Ele.style.boxShadow = "0 1px 3px 0 rgba(43,54,96,0.12)";
    Ele.style.border = "1px solid rgba(43,54,96,0.12)";
    Ele.style.borderRadius = "10px";
    Ele.style.marginTop = "20px";
    const user = this.global.dsUser;
    if (this.global.dsUser) {
      this.setState({
        me_name: user.displayName,
        me_email: user.email,
        me_phone: user.phone
      });
    } else {
      this.setState({
        isForMyself: false
      });
    }
  }

  validate() {
    let isInvalid = false;
    let required = this.required;

    // If the gift card if for a separate recipient, additional required fields.
    if (!this.state.isForMyself) {
      required = [...this.required, ...this.recipientRequired];
    }
    for (let requiredField of required) {
      if (requiredField.validation(this.state[requiredField.name])) {
        document.getElementsByName(requiredField.name)[0].style.boxShadow =
          "0 0 0 2px rgba(230, 63, 63, 0.35)";
        document.getElementsByName(requiredField.name)[0].style.borderColor =
          "#e63f3f";

        isInvalid = true;
      }
    }
    return isInvalid;
  }
  async buyCard() {
    this.setGlobal({ loading: true });

    const isInvalid = this.validate();

    if (isInvalid) {
      this.setGlobal({ loading: false });
      toast.error("Please complete the highlighted fields.");
      return;
    }

    if (!this.state.cc_token) {
      this.setGlobal({ loading: false });
      toast.error("Please complete your credit card information.");
      return;
    }
    const ep = `${process.env.REACT_APP_API}/partners/gifts/buy`;
    console.log({
      state: this.state,
      giftCard: this.props.giftCard,
      global: this.global
    });
    const result = await axios.post(ep, {
      ...this.state,
      giftCard: this.props.gift_card
    });
    if (result.data.success) {
      toast.success(`Gift card purchase successful!`);
      this.setState({
        rec_name: "",
        rec_phone: "",
        rec_email: "",
        message: "",
        cc_token: ""
      });
      this.props.onBack();
    } else {
      toast.error("Credit Card Declined");
    }
    this.setGlobal({ loading: false });
  }
  render() {
    const { gift_card } = this.props;
    const FONT_STACK =
      "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif";
    const inputStyle = {
      margin: "5px 20px 5px 0",
      padding: "10px 12px",
      border: "1px solid rgba(43,54,96,0.15)",
      boxShadow: "0 1px 3px 0 rgba(43,54,96,0.06)",
      borderRadius: "10px",
      width: "100%",
      fontFamily: FONT_STACK,
      fontSize: "13px",
      color: "#2b2f4a",
      outline: "none",
      transition: "border-color 0.15s ease, box-shadow 0.15s ease"
    };
    const inputFocus = e => {
      e.currentTarget.style.borderColor = "#bf80ff";
      e.currentTarget.style.boxShadow = "0 0 0 3px rgba(191, 128, 255, 0.18)";
    };
    const inputBlur = e => {
      e.currentTarget.style.borderColor = "rgba(43,54,96,0.15)";
      e.currentTarget.style.boxShadow = "0 1px 3px 0 rgba(43,54,96,0.06)";
    };
    const coralButtonStyle = {
      background: "linear-gradient(135deg, #ff6663 0%, #f55350 100%)",
      border: "1px solid rgba(255,102,99,0.25)",
      color: "#FFFFFF",
      padding: "12px 28px",
      borderRadius: "999px",
      textAlign: "center",
      marginTop: "16px",
      textDecoration: "none",
      fontFamily: FONT_STACK,
      fontSize: "14px",
      fontWeight: 600,
      letterSpacing: "0.2px",
      cursor: "pointer",
      transform: `scale(${window.innerWidth < 768 ? 0.8 : 1})`,
      transformOrigin: "center",
      display: "inline-block",
      boxShadow: "0 4px 12px rgba(255,102,99,0.28)",
      transition:
        "transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease"
    };

    const coralHoverEnter = e => {
      const baseScale = window.innerWidth < 768 ? 0.8 : 1;
      e.currentTarget.style.transform = `scale(${baseScale}) translateY(-2px)`;
      e.currentTarget.style.boxShadow = "0 8px 20px rgba(255,102,99,0.35)";
      e.currentTarget.style.background =
        "linear-gradient(135deg, #ff7a77 0%, #ff6663 100%)";
    };

    const coralHoverLeave = e => {
      const baseScale = window.innerWidth < 768 ? 0.8 : 1;
      e.currentTarget.style.transform = `scale(${baseScale})`;
      e.currentTarget.style.boxShadow = "0 4px 12px rgba(255,102,99,0.28)";
      e.currentTarget.style.background =
        "linear-gradient(135deg, #ff6663 0%, #f55350 100%)";
    };  
    return (
      <div
        style={{
          display: "flex",
          width: "80%",
          margin: "0 auto",
          fontFamily: FONT_STACK
        }}
      >
        <div
          style={{
            width: "50%",
            borderRadius: "14px",
            marginRight: "30px",
            marginTop: "10px",
            objectFit: "contain"
          }}
        >
          <div style={{ position: "relative", height: "min-content" }}>
            <img
              src={`${process.env.REACT_APP_DS_FILES_S3}/${
                this.state.image_map[gift_card.image - 1]
              }`}
              style={{
                width: "100%",
                borderRadius: "14px",
                boxShadow: "0 4px 16px rgba(43,54,96,0.12)"
              }}
            />
            <p
              style={{
                position: "absolute",
                fontSize: gift_card.image < 4 ? "36px" : "44px",
                fontWeight: "700",
                top:
                  gift_card.image === 1
                    ? "15%"
                    : gift_card.image < 4
                    ? "90%"
                    : "50%",
                left:
                  gift_card.image === 1
                    ? "15%"
                    : gift_card.image < 4
                    ? "85%"
                    : "50%",
                transform: `translate(-50%,-50%) scale(${
                  window.innerWidth < 768 ? 0.4 : 1
                })`,
                color: gift_card.image < 4 ? "#1f3b89" : "white",
                fontFamily: FONT_STACK
              }}
            >
              ${gift_card.amount}
            </p>
          </div>
          <button
            className="savebtn"
            onClick={_ => this.props.onBack()}
            style={coralButtonStyle}
            onMouseEnter={coralHoverEnter}
            onMouseLeave={coralHoverLeave}
          >
            Back
          </button>
        </div>
        <form
          autoComplete="on"
          onSubmit={e => {
            e.preventDefault();
            this.buyCard();
          }}
        >
          <h4
            style={{
              fontFamily: FONT_STACK,
              fontWeight: "600",
              color: "#2b2f4a"
            }}
          >
            {gift_card.gift_name || "Amount"}: $
            {gift_card ? gift_card.amount : ""}
          </h4>
          <div id="gift_own_info">
            <input
              type="text"
              placeholder="Your Name"
              name="me_name"
              autoComplete="section-purchaser name"
              value={this.state.me_name}
              onChange={e => this.setState({ [e.target.name]: e.target.value })}
              style={inputStyle}
              onFocus={inputFocus}
              onBlur={inputBlur}
              disabled={this.global.dsUser}
            />
            <input
              type="text"
              placeholder="Your Phone (optional)"
              name="me_phone"
              autoComplete="section-purchaser tel"
              value={this.state.me_phone}
              onChange={e => this.setState({ [e.target.name]: e.target.value })}
              style={inputStyle}
              onFocus={inputFocus}
              onBlur={inputBlur}
              disabled={this.global.dsUser}
            />
            <br />
            <input
              type="email"
              placeholder="Your Email"
              name="me_email"
              autoComplete="section-purchaser email"
              value={this.state.me_email}
              onChange={e => this.setState({ [e.target.name]: e.target.value })}
              style={inputStyle}
              onFocus={inputFocus}
              onBlur={inputBlur}
              disabled={this.global.dsUser}
            />
          </div>
          {this.global.dsUser ? (
            <div style={{ marginTop: "10px" }}>
              <label
                htmlFor="isForMyself"
                style={{
                  fontFamily: FONT_STACK,
                  color: "#2b2f4a",
                  marginRight: "15px"
                }}
              >
                Are you buying this gift card for someone else?
              </label>
              <Switch
                id="isForMyself"
                name="isForMyself"
                checked={!this.state.isForMyself} // TODO: Buying for oneself is not supported yet
                onClick={e =>
                  this.setState({ [e.target.name]: !e.target.checked })
                }
                color="primary"
              />
            </div>
          ) : (
            <p
              style={{
                fontFamily: FONT_STACK,
                color: "#2b2f4a"
              }}
            >
              To purchase a gift card for your own account, please{" "}
              <b>
                <Link to="/sign-in" style={{ color: "#bf80ff" }}>
                  log in first
                </Link>
              </b>
              .
            </p>
          )}
          {this.state.isForMyself || (
            <>
              <input
                type="text"
                placeholder="Recipient's Name"
                name="rec_name"
                autoComplete="section-recipient name"
                value={this.state.rec_name}
                onChange={e =>
                  this.setState({ [e.target.name]: e.target.value })
                }
                style={inputStyle}
                onFocus={inputFocus}
                onBlur={inputBlur}
              />
              <input
                type="text"
                placeholder="Recipient's Phone (optional)"
                name="rec_phone"
                autoComplete="section-recipient tel"
                value={this.state.rec_phone}
                onChange={e =>
                  this.setState({ [e.target.name]: e.target.value })
                }
                style={inputStyle}
                onFocus={inputFocus}
                onBlur={inputBlur}
              />
              <br />
              <input
                type="email"
                placeholder="Recipient's Email"
                name="rec_email"
                autoComplete="section-recipient email"
                value={this.state.rec_email}
                onChange={e =>
                  this.setState({ [e.target.name]: e.target.value })
                }
                style={inputStyle}
                onFocus={inputFocus}
                onBlur={inputBlur}
              />
              <br />
              <textarea
                placeholder="Message for Recipient (optional)"
                name="message"
                value={this.state.message}
                onChange={e =>
                  this.setState({ [e.target.name]: e.target.value })
                }
                style={inputStyle}
                onFocus={inputFocus}
                onBlur={inputBlur}
                rows={4}
                columns={10}
              />
            </>
          )}
          <div style={{ width: "143%" }}>
            <StripeProvider apiKey={process.env.REACT_APP_STRIPE}>
              <Elements>
                <StripeCmp
                  setToken={token => this.setState({ cc_token: token })}
                />
              </Elements>
            </StripeProvider>
          </div>

          <div style={{ textAlign: "right" }}>
            <button
              type="submit"
              className="savebtn"
              style={coralButtonStyle}
              onMouseEnter={coralHoverEnter}
              onMouseLeave={coralHoverLeave}
            >
              Purchase
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default GiftCardPurchase;
